<template>
  <div class="app">>
    <AppHeader fixed>
      <div class="col-md-3 col-sm-12 col">
        <h3 style="conferencia-titulo cursor: pointer; font-size: 16px" @click="home()">
          Sistema de Participações
        </h3>
      </div>      
      <b-navbar-nav class="ml-auto">
        <b-nav-item style="margin-right: 1rem; width: 10rem;">{{ nome_usuario }}</b-nav-item>
        <DefaultHeaderDropdownAccnt style="margin-right: 2%;"/>
        <!-- <b-nav-item></b-nav-item> -->
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <b-container fluid>
      <b-row>
        <b-col sm="4">
          <b-form-group tabindex="0" label="Selecione a área da conferência:">
            <b-form-select v-model="area_id" @change="carregar()">
              <option :value="null" selected> Selecione a área da conferência </option>
              <option v-for="item in areas" :key="item.id" :value="item.id"> {{item.titulo}}</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
        <!-- <b-row v-for="conferencia in conferencias" :key="conferencia.id">
          <b-col sm="12">
            <b-card img-width="125" tabindex="0" :img-src="endereco(conferencia)" img-left>
              <b-card-body>
                <b-row>
                  <b-col sm="10"><h5 tabindex="0">{{conferencia.nome}}</h5></b-col>
                  <b-col>
                    <b-row align-h="end" v-if="conferencia.situacao === 'Inscrição Aberta' && !conferencia.credenciado">
                      <b-button variant="success" @click="inscricao(conferencia.conferencia_id)" :disabled="disabled_inscricao">
                        <i class="fa fa-sign-in"></i>&nbsp;&nbsp;<span>Inscreva-se</span>
                      </b-button>
                    </b-row>
                    <b-row align-h="end" v-if="conferencia.credenciado">
                      <b-button variant="info" @click="entrar(conferencia.conferencia_id, conferencia.nome)">
                        <i class="fa fa-sign-in"></i>&nbsp;&nbsp;<span>Entrar</span>
                      </b-button>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row><b-col>&nbsp;</b-col></b-row>
                <b-row>
                  <b-col tabindex="0">{{conferencia.descricao}}</b-col>
                </b-row>
              </b-card-body>
            </b-card>
        <b-modal title="Formulário indisponivel" :hide-footer="true" size="lg" v-model="modalMensagem" >
         <b-card-body>
            <b-row> 
              <b-col cols="12" >
                <p style="color: red"><strong>Atenção!</strong></p>
                <p><strong>Este formulário não está mais disponível para preenchimento!</strong></p>
                <p>{{mensagemErro}}</p>
              </b-col>
              <br>
            </b-row>
          </b-card-body>
          </b-modal>
          </b-col>
        </b-row> -->

        <b-row v-for="conferencia in conferencias" :key="conferencia.id">
          <b-col sm="12">
            <b-row>
              <b-col sm="12" md="4" lg="3" xl="2" class="my-image order-1 order-md-1">
                <b-img  :src="endereco(conferencia)" fluid></b-img>
              </b-col>

              <b-col sm="12" md="8" lg="9" xl="10" class="order-2 order-md-2">
                <b-card tabindex="0" >
                  <b-card-body>
                    <b-row>
                      <b-col sm="10"><h5 tabindex="0">{{conferencia.nome}}</h5></b-col>
                      <b-col>
                        <b-row align-h="end" v-if="!conferencia.credenciado && conferencia.situacao === 'Inscrição Aberta'">
                          <b-button variant="success" @click="inscricao(conferencia.conferencia_id)">
                            <i class="fa fa-sign-in"></i>&nbsp;&nbsp;<span>Inscreva-se</span>
                          </b-button>
                        </b-row>
                        <b-row align-h="end" v-if="conferencia.credenciado">
                          <b-button variant="info" @click="entrar(conferencia.conferencia_id, conferencia.nome)">
                            <i class="fa fa-sign-in"></i>&nbsp;&nbsp;<span>Entrar</span>
                          </b-button>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row><b-col>&nbsp;</b-col></b-row>
                    <b-row>
                      <b-col tabindex="0">{{conferencia.descricao}}</b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
              
            </b-row>
          </b-col>
      </b-row>
      
      <b-modal title="Formulário indisponivel" :hide-footer="true" size="lg" v-model="modalMensagem" >
        <b-card-body>
          <b-row> 
            <b-col cols="12" >
              <p style="color: red"><strong>Atenção!</strong></p>
              <p><strong>Este formulário não está mais disponível para preenchimento!</strong></p>
              <p>{{mensagemErro}}</p>
            </b-col>
            <br>
          </b-row>
        </b-card-body>
      </b-modal>


      </b-container>
      <ModalConferenciaPerfil :exibirmodal="false" />
    </div>
  </div>
</template>
<style scoped>
  @media screen and (max-width: 992px) {
    .my-image {
      height: 200px;
    }
  }
.my-image img {
  object-fit: contain;
  height: auto;
  width: 100%;
  margin-bottom: 5px;
  max-height: 200px;
}
</style>
<script>
import Vue from 'vue'
import { Header as AppHeader } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from '@/templates/containers/DefaultHeaderDropdownAccnt'
import SessionStorage from '@/services/session-storage'
import ModalConferenciaPerfil from '@/components/shared/ModalConferenciaPerfil'
import miniToastr from 'mini-toastr'
import { mapState } from 'vuex'

export default {
  name: 'Autenticada',
  components: {
    AppHeader,
    DefaultHeaderDropdownAccnt,
    ModalConferenciaPerfil
  },
  created () {
    this.$store.dispatch('getAreas')
  },
  data () {
    return {
      nome_usuario: '',
      conferencias: [],
      modalMensagem: false,
      mensagemErro: '',
      disabled_inscricao: false,
      area_id: null
    }
  },
  computed: {
    ...mapState({
      areas: state => state.area.lista
    })
  },
  mounted () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    this.carregar()
    
    if(SessionStorage.get('nome_usuario')){
      this.nome_usuario = SessionStorage.get('nome_usuario')
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    carregar () {
      Vue.http.get('api/participante/conferencias/user').then(response => {

        let confs = response.data.data
        Vue.http.post('api/configurarConferencia/buscar', {area_id: this.area_id}).then(response => {
          if (response.body.success) {
            let conferencias = response.body.data
            for(let x in conferencias) {
              conferencias[x].credenciado = false
              Object.keys(confs).forEach(function(k){
                  if (k == conferencias[x].conferencia_id) {
                    conferencias[x].credenciado = true
                  }
              });
            }
            this.conferencias = conferencias
          }
        })
      })
    },
    entrar(conferencia_id, conferencia_atual_nome){

      let user_id = SessionStorage.get('usuario')      
      let perfil_atual_id = null

      Vue.http.post('api/usuario/buscar', {id: user_id}).then(response => {
        let conferencias = response.data.data[0].conferencias
        for (let index in conferencias) {   
          if(conferencias[index].conferencia_id == conferencia_id){         
             perfil_atual_id = conferencias[index].perfil_id
          }            
        }      

        Vue.http.get('api/perfil/' + perfil_atual_id).then(response => {                  
            // Atualiza o perfil atual e a conferência atual
            SessionStorage.set('conferencia_atual_nome', conferencia_atual_nome)
            SessionStorage.set('conferencia_atual_id', conferencia_id)
            SessionStorage.set('perfil_atual_id', perfil_atual_id)
            SessionStorage.set('perfil_atual_nome', response.body.data.nome)

            this.$store.dispatch('configuracaoAtual')

            // Atualiza o token e redireciona para a conferência
            Vue.http.put('api/auth/token/renovacao', {
              'perfil_atual_id' : perfil_atual_id, 
              'conferencia_atual_id': conferencia_id
            }).then(response => {

                // Atualiza o token na session storage
                let token = response.data.data[0]
                SessionStorage.set('token', token)

                this.$store.dispatch('setConferencia', {
                  'conferencia_id': response.data.data.id,
                  'conferencia_nome': response.data.data.nome
                })

                Vue.http.get('api/conferencia/index/' + conferencia_id).then(response => {
                  this.$store.dispatch('setConferencia', {
                    'conferencia_id': response.data.data.id,
                    'conferencia_nome': response.data.data.nome
                  })

                  SessionStorage.set('texto_apresentacao', response.data.data.texto_apresentacao)
                  
                  Vue.http.post('api/configurarConferencia/buscar', {conferencia_id: conferencia_id}).then(response => {
                    if (response.body.success && response.body.data.length > 0) {
                      this.$store.dispatch('setConfigurarConferencia', response.body.data[0])
                    }else{
                      this.$store.dispatch('setConfigurarConferencia', {})
                    }

                    let data = {
                      usuario_id: SessionStorage.get('usuario'),
                      conferencia_id: conferencia_id
                    }
                    Vue.http.post('api/participante/historicoAcesso', data).then(response => {
                       if (response.body.success) {
                          this.$router.push({path: '/conferencia'})
                       }
                    })                     
                  })
                })
              })    
            })      
      })
    },
    inscricao (conferencia) {
      this.$bvModal.msgBoxConfirm('ATENÇÃO! A inscrição é pessoal e intransferível, não sendo permitido o compartilhamento do link de inscrição. Você deve preencher a ficha do seu usuário logado na plataforma.', {
        okTitle: 'Entendido',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.disabled_inscricao = true
          Vue.http.post('api/formulario/inscricao/enviar/' + conferencia, {}).then(response => {
            this.disabled_inscricao = false
            if (response.body.success) {        
              window.open(response.body.data.url_inscricao, '_blank');
            }else{
              alert(response.body.msg)
            }
          }).catch(e => {
            this.disabled_inscricao = false
            this.modalMensagem = true
            this.mensagemErro = e.body.msg
            this.loading = false
          })
        }
      }).catch(erro => {
        console.log(erro)
      })

    },
    endereco (conferencia) {
      return process.env.ROOT_API1 + 'api/configurarConferencia/url/' + conferencia.id + '/' + conferencia.banner
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/Autenticada.vue